import { Injectable } from '@angular/core';

type Message = {
  type: string;
  payload: object | string;
};

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  isReactNativeWebView: boolean;

  constructor() {
    this.isReactNativeWebView = this.checkIfIsReactNativeWebView();
  }

  private postMessage<T extends Message>(message: T) {
    const messageString = JSON.stringify(message);
    console.log('posting message', messageString);
    window.ReactNativeWebView?.postMessage(messageString);
  }

  private checkIfIsReactNativeWebView(): boolean {
    const message = {
      type: 'connection_status',
      payload: 'connected'
    };
    this.postMessage(message);
    return !!window.ReactNativeWebView;
  }

  postDownloadPdfMessage(base64Pdf: string, fileName: string) {
    const message = {
      type: 'download_pdf',
      payload: {
        base64Pdf,
        fileName
      }
    };
    this.postMessage(message);
  }

  postMaterialForWebviewMessage(material: string) {
    const message = {
      type: 'material_for_webview',
      payload: material
    };
    this.postMessage(message);
  }
}
